// token.js
const TOKEN_KEY = 'session_token';
let memToken = null;
// load any persisted token on boot
try {
    memToken = localStorage.getItem(TOKEN_KEY) || null;
}
catch { }
export function getToken(key = null) { try {
    memToken = localStorage.getItem(key || TOKEN_KEY) || null;
}
catch { } return memToken; }
export function setToken(tok, key = null) {
    memToken = tok || null;
    try {
        if (tok)
            localStorage.setItem(key || TOKEN_KEY, tok);
        else
            localStorage.removeItem(key || TOKEN_KEY);
    }
    catch { } // ignore storage errors (e.g., private mode)
}
// keep multiple tabs in sync
if (typeof window !== 'undefined') {
    window.addEventListener('storage', (e) => {
        if (e.key === TOKEN_KEY)
            memToken = e.newValue;
    });
}
